import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { clsx } from 'clsx';
import { FC, Suspense } from 'react';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import {
  createStreamFormActions,
  formInfoBlock,
  formInfoDescription,
  formInfoTitle,
  streamFormActions,
} from '@/components/streams/stream-form/stream-form.css.ts';
import { StripeOnboardingLink } from '@/components/stripe-account/stripe-onboarding-link.tsx';

export const StripeDetailsSubmitted: FC<{
  onClose: () => void;
  redirectTo: OnboardingLinkPage;
}> = ({ onClose, redirectTo }) => {
  const isTablet = useIsTablet();

  return (
    <div>
      <div className={formInfoBlock}>
        <h3 className={formInfoTitle}>
          You&apos;ve created a Stripe seller account. What&apos;s next?
        </h3>
        <p className={formInfoDescription}>
          We will reach out as soon as your Stripe account is verified.
          Verification on Stripe may take some time. When verified, you will be
          able to continue creating a paid stream and start receiving payments.
          In the meantime, please check the verification status and submit
          additional documents{' '}
          <Suspense fallback={'here'}>
            <StripeOnboardingLink variant={'link'} redirectTo={redirectTo}>
              here
            </StripeOnboardingLink>
          </Suspense>
          .
        </p>
      </div>
      <div className={clsx(streamFormActions, createStreamFormActions)}>
        <Button
          onClick={onClose}
          size={isTablet ? 'large' : 'medium'}
          type={'button'}
        >
          Done
        </Button>
      </div>
    </div>
  );
};
